import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import classnames from 'classnames';
import Empty from '../../../_common/components/Empty';
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';
import Note from "./components/Note/Note";
import ModalHeader from "../../../_common/components/ModalHeader";
import ModalContainer from "../../../_common/components/ModalContainer";
import ModalContent from "../../../_common/components/ModalContent";
import ModalButtonsContainer from "../../../_common/components/ModalButtonsContainer";
import ButtonAction from "../../../_common/components/ButtonAction";
import PopupCreateNote from "./components/PopupCreateNote/PopupCreateNote";
import {usePopupNotesContext} from './contexts/PopupNotesContext';
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import themeStyles from "../../../_common/styles/theme.module.scss";
import {buttonCancel, largeButtonsPadding} from "../../../_common/styles/styles";
import {permissionTypes as T, subjects as S} from "../../../_common/constants/permissionSubjects";
import {can} from "../../../_common/components/Permissions";
import {tooltips as TTS} from "../../../_common/constants/tooltips";
import styles from './styles.module.scss';

const PopupNotes = ({firmShumaID}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const {
    createNote,
    resetNoteDetails,
    loading,
    list,
    updateList,
    disabled,
    formik,
    getNoteOptions
  } = usePopupNotesContext();

  const {formatMessage} = useIntl();
  const prefix = 'tab-order-inspections-tasks';
  const headers = [
    '#',
    formatMessage({id: `${prefix}-grid-header-createDate`, defaultMessage: 'Create date'}),
    formatMessage({id: `${prefix}-grid-header-status`, defaultMessage: 'Status'}),
    formatMessage({id: `${prefix}-grid-header-details`, defaultMessage: 'Details'}),
    formatMessage({id: `${prefix}-grid-header-dueDate`, defaultMessage: 'Due date'}),
    formatMessage({id: `${prefix}-grid-header-createUser`, defaultMessage: 'Create user'}),
    formatMessage({id: `${prefix}-grid-header-responsibleUser`, defaultMessage: 'Responsible user'}),
    '',
  ];
  const mapHeaders = (text, index) => {
    return (
      <div className={styles.headerCell} key={index}>
        {text}
      </div>
    );
  };

  const handleCreateUpdate = async () => {
    await createNote(
      formik.values.statusTypeID,
      formik.values.dueDate,
      formik.values.responsibleUserID,
      formik.values.freeText,
    );
    formik.resetForm();
    await updateList();
  };
  const {isGlassTheme} = useGlobalContext();

  const mapNotes = (item, index) => <Note key={index} {...item}/>;

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'cancel'}
        onClick={() => {
          handleShowModal();
          updateList();
          getNoteOptions();
        }}
        disabled={!can(T.FULL, S.INSPECTIONS_PAGE)}
        label={<img src={toAbsoluteUrl('/media/common/Notes_grey.svg')} alt="i" height={24}/>}
        customClassnames={'my-1'}
        title={TTS.CREATE_INSPECTION_NOTE}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'xxl'} customClassnames={'pt-5'}>
        <ModalHeader
          header={[
          formatMessage({id: `updates-for-inspection`, defaultMessage: 'Update for inspection'}),
          firmShumaID
        ].filter(Boolean).join(' - ')}
        />
        <ModalContent customClassnames={'bg-transparent'}>
          <div className={classnames(styles.header,
            {'pr-6': list.length > 5},
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
          )}>
            {headers.map(mapHeaders)}
          </div>
          {loading && <CommonGridSpinner/>}
          {(list.length === 0 && !loading)
            ? <Empty message={formatMessage({id: `${prefix}-grid-no-tasks`, defaultMessage: 'No tasks'})}
                     customContainerClassname={'py-6'}/>
            : (
              <div className={styles.list}>
                {list
                  .sort((a, b) => new Date(b?.createDate) - new Date(a?.createDate))
                  .map(mapNotes)
                }
              </div>
            )
          }
        </ModalContent>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={() => handleCloseModal()}
            label={formatMessage({id: 'button-close', defaultMessage: 'Close'})}
            customClassnames={buttonCancel}
          />
          <PopupCreateNote
            onEdit={handleCreateUpdate}
            onOpen={resetNoteDetails}
            disabled={disabled}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
};

export default PopupNotes;